import _regeneratorRuntime from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _toConsumableArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { Button, Grid, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography, withStyles } from '@material-ui/core';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import uniqBy from 'lodash/uniqBy';
import Loader from '../loader/Loader';
import isFunction from 'lodash/isFunction';
import isEqual from 'lodash/isEqual';
import mapValues from 'lodash/mapValues';
import keyBy from 'lodash/keyBy';
import isObject from 'lodash/isObject';
import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';
import classnames from 'classnames';
import Field from './fields';
import { FieldType } from './Form.models';
import styles from './Form.style';
import Validation from './Form.validation';
import FormDependency from './Form.dependency';
import Dialog from '../dialog/Dialog';
export var POSITION_SEPARATOR = '|';
export var GROUP_SEPARATOR = '.';
/**
 * Сборка списка дефолтных значений, списка наименований полей, списка правил валидации
 * @param fields
 * @param values
 */

var init = function init(fields, values) {
  var _defaultValues = {};
  var _defaultDynamicValues = {};
  var _defaultDynamicGroupValues = {};
  var _labels = {};
  var _rules = {};
  var _dependsOnFields = {};
  var _groupNames = [];
  fields.forEach(function (field) {
    // Если группа полей
    if ('fields' in field) {
      var groupFields = field.fields,
          groupName = field.name,
          isDynamic = field.dynamic;
      var newGroupValues = {};

      _groupNames.push(groupName);

      groupFields.forEach(function (groupField) {
        var groupFieldName = groupField.name,
            groupFieldValue = groupField.value;
        var groupFieldID = "".concat(groupFieldName).concat(GROUP_SEPARATOR).concat(groupName); // если идентификатор поля не уникален

        if (!isUndefined(_labels[groupFieldID])) {
          console.error("\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u043E\u043B\u044F ".concat(groupFieldName, " \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 ").concat(groupName, " \u043D\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u0435\u043D!"));
        }

        var newValue = groupFieldValue;

        if (!isDynamic && values && values[groupName]) {
          newValue = values[groupName][groupFieldName];
        }

        newGroupValues[groupFieldName] = getDefaultValueByFieldType(groupField.type, newValue);

        if (groupField.type !== FieldType.Hidden) {
          _labels[groupFieldID] = groupField.label;

          if (groupField.rule) {
            _rules[groupFieldID] = groupField.rule;
          }

          if (groupField.preFilters) {
            groupField.preFilters.forEach(function (_ref) {
              var dependsOn = _ref.dependsOn;

              if (_dependsOnFields[dependsOn]) {
                if (!_dependsOnFields[dependsOn].includes(groupFieldID)) {
                  _dependsOnFields[dependsOn].push(groupFieldID);
                }
              } else {
                _dependsOnFields[dependsOn] = [groupFieldID];
              }
            });
          }
        }
      });
      _defaultValues[groupName] = newGroupValues; // если группа динамическая

      if (isDynamic) {
        _defaultDynamicGroupValues[groupName] = []; // Если есть значения

        if (values && values[groupName] && isArray(values[groupName])) {
          _defaultDynamicGroupValues[groupName] = values[groupName].map(function (groupValues) {
            return _objectSpread({}, newGroupValues, {}, groupValues);
          });
        }
      }
    } else {
      var fieldValue = field.value,
          fieldName = field.name;

      var _isDynamic = 'dynamic' in field && field.dynamic; // если идентификатор поля не уникален


      if (!isUndefined(_labels[fieldName])) {
        console.error("\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u043E\u043B\u044F ".concat(fieldName, " \u043D\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u0435\u043D!"));
      }

      var newValue = getDefaultValueByFieldType(field.type, fieldValue); // если поле динамическое

      if (_isDynamic) {
        _defaultDynamicValues[fieldName] = []; // если есть значения

        if (values && values[fieldName] && isArray(values[fieldName])) {
          values[fieldName].forEach(function (value) {
            _defaultDynamicValues[fieldName].push(value || newValue);
          });
        } else {
          _defaultDynamicValues[fieldName].push(newValue);
        }
      } else {
        // если переданы значения и поле не содержит значение
        if (values && values[fieldName]) {
          newValue = values[fieldName];
        }

        _defaultValues[fieldName] = newValue;
      }

      if (field.type !== FieldType.Hidden) {
        _labels[fieldName] = field.label;

        if (field.rule) {
          _rules[fieldName] = field.rule;
        }

        if (field.preFilters) {
          field.preFilters.forEach(function (_ref2) {
            var dependsOn = _ref2.dependsOn;

            if (_dependsOnFields[dependsOn]) {
              if (!_dependsOnFields[dependsOn].includes(fieldName)) {
                _dependsOnFields[dependsOn].push(fieldName);
              }
            } else {
              _dependsOnFields[dependsOn] = [fieldName];
            }
          });
        }
      }
    }
  });

  var _excludedDependencies = checkCyclicalDependence(_dependsOnFields);

  var _loop = function _loop(excludedDependency) {
    var _excludedDependency$s = excludedDependency.split(GROUP_SEPARATOR),
        _excludedDependency$s2 = _slicedToArray(_excludedDependency$s, 2),
        dependentFieldName = _excludedDependency$s2[0],
        dependentGroupName = _excludedDependency$s2[1];

    var dependentTextName = "".concat(dependentFieldName, " ").concat(dependentGroupName ? 'в группе ' + dependentGroupName : '');
    var dependsOn = _excludedDependencies[excludedDependency];
    dependsOn.forEach(function (dependsOnField) {
      var _dependsOnField$split = dependsOnField.split(GROUP_SEPARATOR),
          _dependsOnField$split2 = _slicedToArray(_dependsOnField$split, 2),
          dependsOnFieldName = _dependsOnField$split2[0],
          dependsOnGroupName = _dependsOnField$split2[1];

      var dependsOnTextName = "".concat(dependsOnFieldName, " ").concat(dependsOnGroupName ? "\u0432 \u0433\u0440\u0443\u043F\u043F\u0435 ".concat(dependsOnGroupName) : '');
      var errorMessage = "\n              \u041F\u0440\u0435\u0444\u0438\u043B\u044C\u0442\u0440\u044B \u043F\u043E\u043B\u0435\u0439 ".concat(dependentTextName, " \u0438 ").concat(dependsOnTextName, " \u043F\u043E\u0440\u043E\u0436\u0434\u0430\u044E\u0442 \u0446\u0438\u043A\u043B\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u044C!\n              \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0440\u0435\u0444\u0438\u043B\u044C\u0442\u0440\u0430 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0435\u0439!\n              \u041F\u0440\u0435\u0444\u0438\u043B\u044C\u0442\u0440 \u043F\u043E\u043B\u044F ").concat(dependentTextName, " \u043F\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u043F\u043E\u043B\u044F ").concat(dependsOnTextName, " \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D!\n              ");
      console.error(errorMessage);
    });
  };

  for (var excludedDependency in _excludedDependencies) {
    _loop(excludedDependency);
  }

  return {
    _defaultValues: _defaultValues,
    _defaultDynamicValues: _defaultDynamicValues,
    _defaultDynamicGroupValues: _defaultDynamicGroupValues,
    _labels: _labels,
    _rules: _rules,
    _excludedDependencies: _excludedDependencies,
    _dependsOnFields: _dependsOnFields,
    _groupNames: _groupNames
  };
};
/**
 * Поиск циклических зависимостей. Возвращает список наименований полей с массивом наименований
 * исключенных правил префильтрации
 * @param dependOnFields
 */


var checkCyclicalDependence = function checkCyclicalDependence(dependOnFields) {
  var chains = {};
  var excludedChainParts = {};
  var excludedDependencies = {};

  var check = function check(dependOnFieldKey, chainKey) {
    if (chains[chainKey]) {
      chains[chainKey].push(dependOnFieldKey);
    } else {
      chains[chainKey] = [dependOnFieldKey];
    }

    var chain = chains[chainKey];

    if (dependOnFields[dependOnFieldKey]) {
      dependOnFields[dependOnFieldKey].forEach(function (dependKey, index) {
        var newChainKey = "".concat(chainKey, "#").concat(index);
        chains[newChainKey] = _toConsumableArray(chain);

        if (!chain.includes(dependKey)) {
          if (!excludedChainParts[dependOnFieldKey] || excludedChainParts[dependOnFieldKey] !== dependKey) {
            check(dependKey, newChainKey);
          }
        } else {
          chains[newChainKey].push(dependKey);
          excludedChainParts[dependOnFieldKey] = dependKey;
          var startDependKey = chains[newChainKey][1];

          if (excludedDependencies[startDependKey]) {
            excludedDependencies[startDependKey].push(dependKey);
          } else {
            excludedDependencies[startDependKey] = [dependKey];
          }
        } // оставляем только самые длинные цепочки


        delete chains[chainKey];
      });
    }
  };

  var dependOnFieldKeys = Object.keys(dependOnFields);
  dependOnFieldKeys.forEach(function (dependOnFieldKey) {
    check(dependOnFieldKey, dependOnFieldKey);
  });
  return excludedDependencies;
};

var fieldChangeValidationTimeout = 250;
/**
 * Нужно чтобы пустое значение привести к соответствующему для поля типу.
 * Например undefined не подходит для текстовых полей, а '' не подходит для селектов и т.д.
 * @param fieldType
 * @param value
 */

var getDefaultValueByFieldType = function getDefaultValueByFieldType(fieldType, value) {
  if (value) {
    return value;
  }

  switch (fieldType) {
    case FieldType.Hidden:
    case FieldType.Text:
    case FieldType.Email:
    case FieldType.Password:
    case FieldType.Number:
    case FieldType.Search:
    case FieldType.Textarea:
    case FieldType.Date:
    case FieldType.DateTime:
    case FieldType.Time:
      return '';

    case FieldType.Checkbox:
    case FieldType.Radio:
    case FieldType.Switch:
      return false;

    default:
      return undefined;
  }
};
/**
 * Обновление данных
 * @param name
 * @param prevState
 * @param nextPropsValues
 */


var getMergedValues = function getMergedValues(name, prevState, nextPropsValues) {
  var values = _objectSpread({}, prevState[name]);

  Object.keys(values).forEach(function (key) {
    if (!isUndefined(nextPropsValues) && !isUndefined(nextPropsValues[key])) {
      values[key] = nextPropsValues[key];
    }
  });
  return values;
};

export var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));
    /**
     * Список наименований полей
     */

    _this._labels = {};
    /**
     * Список полей с отключенным правилом префильтра
     */

    _this._excludedDependencies = {};
    /**
     * Список полей с массивом ID зависимых полей
     */

    _this._dependsOnFields = {};
    /**
     * Список скрытых полей
     */

    _this.hiddenFields = [];
    /**
     * Id таймера запуска валидации при изменение значения поля
     */

    _this.fieldChangeValidationTimerId = {};
    /**
     * Вызывает наблюдателя изменений значений формы
     */

    _this.valueObserver = function () {
      if (_this.props.valueObserver) {
        _this.props.valueObserver(_this.getFormValues());
      }
    };

    _this.handleFormChange = function (ID) {
      var onChange = _this.props.onChange;
      if (onChange) onChange(ID, _this.formHelpers);
    };
    /**
     * Валидация формы
     */


    _this.validateAll = function (callback) {
      // Если есть, то вызываем beforeValidate
      if (isFunction(_this.props.beforeValidate)) {
        _this.props.beforeValidate(_assertThisInitialized(_this));
      }

      if (!isUndefined(_this._validator)) {
        var _this$state = _this.state,
            values = _this$state.values,
            dynamicValues = _this$state.dynamicValues,
            dynamicGroupValues = _this$state.dynamicGroupValues;

        var validateValues = _objectSpread({}, values, {}, dynamicValues); // убираем значения динамических групп из валидации, т.к. они уже провалидированы при сохранении
        // todo реализовать обязательность группы для заполнения (добавить параметр в конфиг required) с выводом ошибки


        var noValidateKeys = [].concat(_toConsumableArray(Object.keys(dynamicGroupValues)), _toConsumableArray(_this.hiddenFields));
        noValidateKeys.forEach(function (key) {
          if (validateValues[key]) {
            delete validateValues[key];
          }
        });

        _this._validator.checkAll(validateValues, _this._labels, noValidateKeys, Object.keys(dynamicValues)).then(function (errors) {
          _this.setState({
            errors: mapValues(keyBy(errors, 'id'), 'errors')
          }, function () {
            callback(); // Если есть, то вызываем afterValidate

            if (isFunction(_this.props.afterValidate)) {
              _this.props.afterValidate(_assertThisInitialized(_this));
            }
          });
        });
      } else {
        callback(); // Если есть, то вызываем afterValidate

        if (isFunction(_this.props.afterValidate)) {
          _this.props.afterValidate(_assertThisInitialized(_this));
        }
      }
    };
    /**
     * Возвращает значения по ID поля. В качестве ID может быть:
     *  - имя отдельного поля вида <имя_поля>[.<группа>]
     *  - имя динамического поля вида <имя_поля>[.<группа>]
     *  - имя группы вида .<имя_группы> (точка в начале обязательна)
     *  - имя отдельной записи динамического поля вида
     *    <имя_поля>[.<имя_группы>]|<индекс_записи>
     *  - имя отдельной записи динамической группы вида
     *    .<имя_группы>|<индекс_записи>
     * @param ID
     */


    _this.getFieldValue = function (ID) {
      var _this$state2 = _this.state,
          values = _this$state2.values,
          dynamicValues = _this$state2.dynamicValues,
          dynamicGroupValues = _this$state2.dynamicGroupValues;

      var _ID$split = ID.split(POSITION_SEPARATOR),
          _ID$split2 = _slicedToArray(_ID$split, 2),
          id = _ID$split2[0],
          position = _ID$split2[1];

      var _id$split = id.split(GROUP_SEPARATOR),
          _id$split2 = _slicedToArray(_id$split, 2),
          name = _id$split2[0],
          groupName = _id$split2[1];

      var value;

      if (position) {
        if (groupName) value = dynamicGroupValues[groupName][Number(position)];else value = dynamicValues[id][Number(position)];
      } else {
        if (dynamicValues[id]) value = dynamicValues[id];else if (groupName) {
          // из группы полей
          if (name) value = values[groupName][name];else if (dynamicGroupValues[groupName]) value = dynamicGroupValues[groupName];else value = values[groupName];
        } else {
          // одиночное поле
          value = values[name]; // todo разобраться с as
        }
      }

      return value;
    };

    _this.validateField = function (ID, value) {
      var addValidate = function addValidate(ID, value) {
        if (!_this.hiddenFields.includes(ID)) {
          // Если таймер запущен, очищаем таймер
          if (_this.fieldChangeValidationTimerId[ID]) {
            window.clearTimeout(_this.fieldChangeValidationTimerId[ID]);
            delete _this.fieldChangeValidationTimerId[ID];
          } // запускаем таймер с валидацией


          _this.fieldChangeValidationTimerId[ID] = window.setTimeout(function () {
            var _this$state3 = _this.state,
                values = _this$state3.values,
                stateErrors = _this$state3.errors;
            if (value === undefined) value = _this.getFieldValue(ID);

            _this.setState({
              validationField: ID
            });

            _this._validator.checkOne(ID, value, values, _this._labels).then(function (errors) {
              var newErrors = _objectSpread({}, stateErrors);

              if (errors.length > 0) {
                newErrors[ID] = errors;
              } else {
                delete newErrors[ID];
              }

              _this.setState({
                errors: newErrors,
                validationField: undefined
              }); // очищаем таймер


              window.clearTimeout(_this.fieldChangeValidationTimerId[ID]);
              delete _this.fieldChangeValidationTimerId[ID];
            });
          }, fieldChangeValidationTimeout);
        }
      };

      if (!_this._validator) return;
      addValidate(ID, value);

      _this._validator.getDependsFields(ID).forEach(function (dependsID) {
        return addValidate(dependsID, _this.getFieldValue(dependsID));
      });
    };
    /**
     * Изменение значения поля
     * @param ID Идентификатор поля
     * @param value Новое значение поля
     * @param silent Без изменения параметра нетронутости формы
     * @param hard С изменением в дефолтных данных
     */


    _this.onFieldChange = function (ID, value, silent, hard) {
      var _this$state4 = _this.state,
          values = _this$state4.values,
          pristine = _this$state4.pristine,
          dynamicValues = _this$state4.dynamicValues,
          dynamicGroupValues = _this$state4.dynamicGroupValues;
      var fireDynamicGroupFormChange = _this.props.fireDynamicGroupFormChange;

      var _ID$split3 = ID.split(POSITION_SEPARATOR),
          _ID$split4 = _slicedToArray(_ID$split3, 2),
          id = _ID$split4[0],
          position = _ID$split4[1];

      var _id$split3 = id.split(GROUP_SEPARATOR),
          _id$split4 = _slicedToArray(_id$split3, 2),
          name = _id$split4[0],
          groupName = _id$split4[1];

      _this.validateField(ID, value);

      var newMainState = {
        pristine: silent ? pristine : pristine ? false : pristine
      };
      var newState;

      if (position) {
        // если поле динамическое, то правим dynamicValues
        var newValues = _toConsumableArray(dynamicValues[name]);

        newValues.splice(Number(position), 1, value);
        newState = _objectSpread({}, newMainState, {
          dynamicValues: _objectSpread({}, dynamicValues, _defineProperty({}, name, newValues))
        });
      } else {
        // если не динамическое, то правим values
        var _newValues = groupName ? _objectSpread({}, values, _defineProperty({}, groupName, _objectSpread({}, values[groupName], _defineProperty({}, name, value)))) : _objectSpread({}, values, _defineProperty({}, name, value));
        /**
         * TODO: Выключил логику сброса зависимых полей в значения по умолчанию при изменении мастер-поля,
         * поскольку в ней нет необходимости. Зависящие поля должны сами решать как и во что им изменять свое
         * значение при изменении мастер поля. Кроме того, логика сброса мешала механизму автоселекта
         * TODO: Удалить данную строку, а так же сам метод clearDependentFields и свойства _dependsOnFields
         * если отключение данного механизма не приведет к непоправимым багам.
         */
        // Сбрасываем значения зависимых полей
        //this.clearDependentFields(ID, newValues);


        newState = _objectSpread({}, newMainState, {
          values: _newValues
        });
      }

      var newDefaultValuesState = {};

      if (hard) {
        var _this$state5 = _this.state,
            defaultValues = _this$state5.defaultValues,
            defaultDynamicValues = _this$state5.defaultDynamicValues,
            defaultDynamicGroupValues = _this$state5.defaultDynamicGroupValues;

        if (position) {
          // если поле динамическое из группы, то правим defaultDynamicGroupValues
          if (groupName) {
            var newDefaultValues = _toConsumableArray(defaultDynamicGroupValues[groupName]);

            if (Number(position) < newDefaultValues.length) {
              // если есть дефолтное значение на этой позиции
              newDefaultValues.splice(Number(position), 1, _objectSpread({}, defaultDynamicGroupValues[groupName][position], _defineProperty({}, name, value)));
              newDefaultValuesState = {
                defaultDynamicGroupValues: _objectSpread({}, defaultDynamicGroupValues, _defineProperty({}, groupName, newDefaultValues))
              };
            }
          } else {
            // если поле динамическое, то правим defaultDynamicValues
            var _newDefaultValues = _toConsumableArray(defaultDynamicValues[name]);

            if (Number(position) < _newDefaultValues.length) {
              // если есть дефолтное значение на этой позиции
              _newDefaultValues.splice(Number(position), 1, value);

              newDefaultValuesState = {
                defaultDynamicValues: _objectSpread({}, defaultDynamicValues, _defineProperty({}, name, _newDefaultValues))
              };
            }
          }
        } else {
          // если не динамическое, то правим values
          var _newDefaultValues2 = groupName ? _objectSpread({}, defaultValues, _defineProperty({}, groupName, _objectSpread({}, defaultValues[groupName], _defineProperty({}, name, value)))) : _objectSpread({}, defaultValues, _defineProperty({}, name, value));

          newDefaultValuesState = {
            defaultValues: _newDefaultValues2
          };
        }
      }

      _this.setState(_objectSpread({}, newState, {}, newDefaultValuesState), function () {
        if (fireDynamicGroupFormChange || !dynamicGroupValues[groupName]) _this.handleFormChange(ID); // если поле не из динамических

        if (!dynamicValues[name] && !dynamicGroupValues[groupName]) {
          _this.valueObserver();
        }
      });
    };
    /**
     * Сброс значений зависимых полей
     * @param ID
     * @param newValues
     */


    _this.clearDependentFields = function (ID, newValues) {
      if (_this._dependsOnFields[ID]) {
        var defaultValues = _this.state.defaultValues;

        _this._dependsOnFields[ID].forEach(function (dependentID) {
          if (!_this._excludedDependencies[dependentID] || !_this._excludedDependencies[dependentID].includes(ID)) {
            _this.clearDependentFields(dependentID, newValues);

            var _dependentID$split = dependentID.split(GROUP_SEPARATOR),
                _dependentID$split2 = _slicedToArray(_dependentID$split, 2),
                dependentFieldName = _dependentID$split2[0],
                dependentGroupName = _dependentID$split2[1];

            if (dependentGroupName) {
              newValues[dependentGroupName][dependentFieldName] = defaultValues[dependentGroupName][dependentFieldName];
            } else {
              newValues[dependentFieldName] = defaultValues[dependentFieldName];
            }
          }
        });
      }
    };
    /**
     * Формирование данных для отправки
     */


    _this.getFormValues = function () {
      var _this$state6 = _this.state,
          values = _this$state6.values,
          dynamicValues = _this$state6.dynamicValues,
          dynamicGroupValues = _this$state6.dynamicGroupValues;
      var formValues = cloneDeep(_objectSpread({}, values, {}, dynamicValues, {}, dynamicGroupValues));
      /** Удаление значений скрытых полей */

      _this.hiddenFields.forEach(function (hiddenField) {
        var _hiddenField$split = hiddenField.split(GROUP_SEPARATOR),
            _hiddenField$split2 = _slicedToArray(_hiddenField$split, 2),
            hiddenFieldName = _hiddenField$split2[0],
            hiddenFieldGroupName = _hiddenField$split2[1];

        if (hiddenFieldGroupName) {
          if (!dynamicGroupValues[hiddenFieldGroupName]) {
            formValues[hiddenFieldGroupName][hiddenFieldName] = undefined;
          } else {
            formValues[hiddenFieldGroupName].forEach(function (formDynamicGroupValues) {
              formDynamicGroupValues[hiddenFieldName] = undefined;
            });
          }
        } else {
          if (!dynamicValues[hiddenFieldName]) {
            formValues[hiddenFieldName] = undefined;
          }
        }
      });

      return formValues;
    };
    /**
     * Получение типа поля по его ID
     * @param ID
     */


    _this.getFieldTypeByID = function (ID) {
      var _ID$split5 = ID.split(POSITION_SEPARATOR),
          _ID$split6 = _slicedToArray(_ID$split5, 1),
          id = _ID$split6[0];

      var _id$split5 = id.split(GROUP_SEPARATOR),
          _id$split6 = _slicedToArray(_id$split5, 2),
          fieldName = _id$split6[0],
          groupName = _id$split6[1];

      var type;

      _this.props.fields.forEach(function (field) {
        if (groupName && field.name === groupName && 'fields' in field) {
          field.fields.forEach(function (groupField) {
            if (groupField.name === fieldName) {
              type = groupField.type;
            }
          });
        } else if (!('fields' in field) && field.name === fieldName) {
          type = field.type;
        }
      });

      return type;
    };

    _this.getClearedValues = function (values) {
      var clearedValues = {};
      var disabledFields = _this.props.disabledFields;

      for (var key in values) {
        if (values.hasOwnProperty(key)) {
          if (_this._groupNames.includes(key) && isObject(values[key])) {
            clearedValues[key] = _this.getClearedValues(values[key]);
          } else {
            clearedValues[key] = disabledFields && disabledFields.includes(key) ? values[key] : getDefaultValueByFieldType(_this.getFieldTypeByID(key));
          }
        }
      }

      return clearedValues;
    };

    _this.getClearedDynamicValues = function (values) {
      var clearedValues = {};

      if (isObject(values)) {
        for (var key in values) {
          if (values.hasOwnProperty(key)) {
            clearedValues[key] = [];
          }
        }
      }

      return clearedValues;
    };

    _this.getClearedDynamicGroupValues = function (values) {
      var clearedValues = {};

      if (isObject(values)) {
        for (var key in values) {
          if (values.hasOwnProperty(key)) {
            clearedValues[key] = [];
          }
        }
      }

      return clearedValues;
    };
    /**
     * Проверка данных перед сабмитом
     */


    _this.onSubmit = function (event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      event.preventDefault();

      _this.validateAll(function () {
        var _this$state7 = _this.state,
            openedDynamicGroup = _this$state7.openedDynamicGroup,
            values = _this$state7.values,
            defaultValues = _this$state7.defaultValues,
            errors = _this$state7.errors;
        var submitStrategy = _this.props.submitStrategy;

        if (!isEmpty(errors)) {
          return;
        }

        if (!submitStrategy || submitStrategy === 'default') {
          _this.submit();
        } else {
          var isNeedToSaveDynamicGroup = openedDynamicGroup && !isEqual(values[openedDynamicGroup], defaultValues[openedDynamicGroup]);

          if (isNeedToSaveDynamicGroup && submitStrategy === 'save') {
            _this.onSaveDynamicGroup().then(function (dynamicGroupErrors) {
              if (!dynamicGroupErrors) {
                _this.submit();
              }
            });
          } else if (isNeedToSaveDynamicGroup && submitStrategy === 'warn') {
            _this.setState({
              notSavedDynamicGroup: openedDynamicGroup,
              showSubmitConfirm: true
            });
          } else {
            _this.submit();
          }
        }
      });
    };
    /**
     * Сабмит формы
     */


    _this.submit = function () {
      _this.setState({
        submitting: true,
        submitted: true
      }, function () {
        // todo нужно отрефакторить сброс состояния загрузки. Возможно через props.loading
        _this.props.onSubmit(_this.getFormValues(), function () {
          return _this.setState({
            submitting: false
          });
        });
      });
    };
    /**
     * Сброс формы к дефолтным значениям
     */


    _this.onReset = function (event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      event.preventDefault();
      var _this$props = _this.props,
          valueObserver = _this$props.valueObserver,
          type = _this$props.type,
          onSubmit = _this$props.onSubmit,
          afterReset = _this$props.afterReset;
      var _this$state8 = _this.state,
          defaultValues = _this$state8.defaultValues,
          defaultDynamicValues = _this$state8.defaultDynamicValues,
          defaultDynamicGroupValues = _this$state8.defaultDynamicGroupValues;
      var asGridFilter = type === 'filter';

      _this.setState({
        values: asGridFilter ? _this.getClearedValues(defaultValues) : defaultValues,
        dynamicValues: asGridFilter ? _this.getClearedDynamicValues(defaultDynamicValues) : defaultDynamicValues,
        dynamicGroupValues: asGridFilter ? _this.getClearedDynamicGroupValues(defaultDynamicGroupValues) : defaultDynamicGroupValues,
        pristine: true,
        errors: {}
      }, function () {
        var submitted = _this.state.submitted;

        var formValues = _this.getFormValues();

        _this.handleFormChange();

        if (valueObserver) {
          valueObserver(formValues);
        } // Если используется как фильтр для грида , то вызываем сабмит с дефолтными значениями


        if (asGridFilter) {
          onSubmit(formValues);
        }

        if (submitted) {
          if (afterReset) {
            afterReset(formValues);
          }
        }
      });
    };
    /**
     * Проверка поля на скрытость
     * @param field
     */


    _this.isFieldHidden = function (field) {
      if (field.type === FieldType.Hidden || !field.dependency || field.dependency.type !== 'hidden') {
        return false;
      }

      return _this.fieldDependency.resolve(field.dependency);
    };
    /**
     * Проверка поля на заблокированность
     * @param field
     */


    _this.isFieldDisabled = function (field) {
      if (_this.props.readonly) {
        return true;
      }

      if (field.type === FieldType.Hidden) {
        return false;
      }

      var disabledFields = _this.props.disabledFields;

      if (!field.dependency || field.dependency.type !== 'disabled') {
        return disabledFields ? disabledFields.includes(field.name) : false;
      }

      return _this.fieldDependency.resolve(field.dependency);
    };
    /**
     * Проверяет наличие ошибок группы
     * @param groupName
     */


    _this.isGroupErrors = function (groupName) {
      var errors = _this.state.errors;
      return Object.keys(errors).join(POSITION_SEPARATOR).indexOf(GROUP_SEPARATOR + groupName) >= 0;
    };
    /**
     * Сбор значений для префильтра зависимого поля
     * @param field
     * @param ID
     */


    _this.getFieldPreFilterValues = function (field, ID) {
      var values = _this.state.values;
      var preFilterValues = {};

      if ('preFilters' in field) {
        field.preFilters.forEach(function (preFilter) {
          if (!_this._excludedDependencies[ID] || !_this._excludedDependencies[ID].includes(preFilter.dependsOn)) {
            var _preFilter$dependsOn$ = preFilter.dependsOn.split(GROUP_SEPARATOR),
                _preFilter$dependsOn$2 = _slicedToArray(_preFilter$dependsOn$, 2),
                dependsOnField = _preFilter$dependsOn$2[0],
                dependsOnGroup = _preFilter$dependsOn$2[1];

            if (dependsOnGroup && values.hasOwnProperty(dependsOnGroup)) {
              // preFilterValues[preFilter.paramName] = this.formatValueForFilterParams(values[dependsOnGroup][dependsOnField]);
              preFilterValues[preFilter.paramName] = values[dependsOnGroup][dependsOnField];
            } else if (values.hasOwnProperty(dependsOnField)) {
              // preFilterValues[preFilter.paramName] = this.formatValueForFilterParams(values[dependsOnField]);
              preFilterValues[preFilter.paramName] = values[dependsOnField];
            }
          }
        });
      }

      return isEmpty(preFilterValues) ? undefined : preFilterValues;
    };
    /**
     * Получение значения для фильтра зависимых полей
     * @param value
     */


    _this.formatValueForFilterParams = function (value) {
      if (!value) {
        return '';
      }

      if (isObject(value)) {
        if (value.hasOwnProperty('id')) {
          return String(value['id']);
        }

        if (value.hasOwnProperty('value')) {
          return String(value['value']);
        }

        if (isArray(value)) {
          return value.map(function (item) {
            return _this.formatValueForFilterParams(item);
          }).join(', ');
        }
      }

      return String(value);
    };
    /**
     * Скрытие диалогового окна показанного при сабмите
     */


    _this.onCloseSubmitConfirm = function () {
      _this.setState({
        showSubmitConfirm: false
      });
    };
    /**
     * Сабмит формы из диалогового окна
     */


    _this.onSubmitConfirm = function () {
      _this.setState({
        showSubmitConfirm: false
      }, function () {
        _this.onCloseDynamicGroupForm(_this.submit);
      });
    };
    /**
     * Получение значения из справочника для вывода в списке
     * @param field
     * @param value
     */


    _this.getDynamicGroupGridValue = function (field, value) {
      var newValue = '';

      if (field) {
        switch (field.type) {
          case FieldType.Find:
            //todo преобразовать объект в строку согласно шаблону
            newValue = '';
            break;

          case FieldType.Select:
          case FieldType.Autocomplete:
          case FieldType.AsyncAutocomplete:
            newValue = value ? value.label : '';
            break;

          case FieldType.MultiSelect:
          case FieldType.MultiAutocomplete:
          case FieldType.AsyncMultiAutocomplete:
            newValue = value ? value.map(function (currentValue) {
              return currentValue.label;
            }).join(', ') : '';
            break;

          case FieldType.Checkbox:
          case FieldType.Switch:
            newValue = value ? 'Да' : 'Нет';
        }
      }

      return newValue || value;
    };
    /**
     * Выбор строки в динамической группе
     */


    _this.onSelectDynamicGroup = function (name, position) {
      var _this$state9 = _this.state,
          openedDynamicGroup = _this$state9.openedDynamicGroup,
          selectedDynamicGroup = _this$state9.selectedDynamicGroup; // Если форма еще не открыта

      if (!openedDynamicGroup) {
        var newSelectedDynamicGroup = {
          name: name,
          position: position
        };

        if (selectedDynamicGroup && selectedDynamicGroup.name === name && selectedDynamicGroup.position === position) {
          newSelectedDynamicGroup = undefined;
        }

        _this.setState({
          selectedDynamicGroup: newSelectedDynamicGroup
        });
      }
    };
    /**
     * Закрытие формы динамической группы полей
     */


    _this.onCloseDynamicGroupForm = function (cb) {
      var _this$state10 = _this.state,
          errors = _this$state10.errors,
          groupName = _this$state10.openedDynamicGroup;

      var newErrors = _objectSpread({}, errors);

      if (groupName && _this.isGroupErrors(groupName)) {
        // Очищаем ошибки данной группы при закрытии формы
        Object.keys(newErrors).filter(function (key) {
          return key.indexOf(GROUP_SEPARATOR + groupName) >= 0 && newErrors[key];
        }).forEach(function (key) {
          delete newErrors[key];
        });
      }

      _this.setState({
        errors: newErrors,
        openedDynamicGroup: undefined,
        notSavedDynamicGroup: undefined
      }, function () {
        var onDynamicGroupFormToggle = _this.props.onDynamicGroupFormToggle;

        if (onDynamicGroupFormToggle) {
          onDynamicGroupFormToggle();
        }

        cb && cb();
      });
    };
    /**
     * Открытие формы динамической группы полей на добавление
     * @param name
     */


    _this.onOpenDynamicGroupAddForm = function (name) {
      var _this$state11 = _this.state,
          values = _this$state11.values,
          defaultValues = _this$state11.defaultValues;

      _this.setState({
        openedDynamicGroup: name,
        selectedDynamicGroup: undefined,
        values: _objectSpread({}, values, _defineProperty({}, name, _objectSpread({}, defaultValues[name])))
      }, function () {
        var onDynamicGroupFormToggle = _this.props.onDynamicGroupFormToggle;

        if (onDynamicGroupFormToggle) {
          onDynamicGroupFormToggle(name);
        }
      });
    };
    /**
     * Открытие формы динамической группы полей на редактирование
     */


    _this.onOpenDynamicGroupEditForm = function (selectedOpts) {
      var _this$state12 = _this.state,
          values = _this$state12.values,
          dynamicGroupValues = _this$state12.dynamicGroupValues,
          selectedDynamicGroup = _this$state12.selectedDynamicGroup,
          openedDynamicGroup = _this$state12.openedDynamicGroup;
      if (!selectedOpts) selectedOpts = selectedDynamicGroup;
      if (openedDynamicGroup || !selectedOpts) return;
      var _selectedOpts = selectedOpts,
          name = _selectedOpts.name,
          position = _selectedOpts.position;

      _this.setState({
        selectedDynamicGroup: selectedOpts,
        openedDynamicGroup: name,
        values: _objectSpread({}, values, _defineProperty({}, name, _objectSpread({}, dynamicGroupValues[name][position])))
      }, function () {
        var onDynamicGroupFormToggle = _this.props.onDynamicGroupFormToggle;

        if (onDynamicGroupFormToggle) {
          onDynamicGroupFormToggle(name);
        }
      });
    };
    /**
     * Сохранение значений динамической группы полей
     */


    _this.onSaveDynamicGroup =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var groupName, errors, _this$state13, values, dynamicGroupValues, selectedDynamicGroup, stateErrors, defaultValues, newDynamicGroupValuesArray, newDynamicGroupValues;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              groupName = _this.state.openedDynamicGroup;
              errors = false;

              if (!groupName) {
                _context.next = 11;
                break;
              }

              _this$state13 = _this.state, values = _this$state13.values, dynamicGroupValues = _this$state13.dynamicGroupValues, selectedDynamicGroup = _this$state13.selectedDynamicGroup, stateErrors = _this$state13.errors, defaultValues = _this$state13.defaultValues;
              newDynamicGroupValuesArray = _toConsumableArray(dynamicGroupValues[groupName]);
              newDynamicGroupValues = values[groupName];

              if (isUndefined(_this._validator)) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return _this._validator.checkDynamicGroup(groupName, newDynamicGroupValues, _this._labels, _this.hiddenFields).then(function (errors) {
                if (errors.length > 0) {
                  var newErrors = {};
                  errors.forEach(function (error) {
                    newErrors[error.id] = error.errors;
                  });

                  _this.setState({
                    errors: _objectSpread({}, stateErrors, {}, newErrors)
                  });

                  return true;
                }

                return false;
              });

            case 9:
              errors = _context.sent;

            case 10:
              if (!errors) {
                if (selectedDynamicGroup) {
                  // если редактируем
                  newDynamicGroupValuesArray.splice(selectedDynamicGroup.position, 1, newDynamicGroupValues);
                } else {
                  // если добавляем
                  newDynamicGroupValuesArray.push(newDynamicGroupValues);
                }

                _this.setState({
                  dynamicGroupValues: _objectSpread({}, dynamicGroupValues, _defineProperty({}, groupName, newDynamicGroupValuesArray)),
                  openedDynamicGroup: undefined,
                  notSavedDynamicGroup: undefined,
                  values: _objectSpread({}, values, _defineProperty({}, groupName, _objectSpread({}, defaultValues[groupName])))
                }, function () {
                  var onDynamicGroupFormToggle = _this.props.onDynamicGroupFormToggle;

                  if (onDynamicGroupFormToggle) {
                    onDynamicGroupFormToggle();
                  }

                  _this.handleFormChange(GROUP_SEPARATOR + groupName + POSITION_SEPARATOR + (selectedDynamicGroup ? selectedDynamicGroup.position : newDynamicGroupValuesArray.length - 1).toString());

                  _this.valueObserver();
                });
              }

            case 11:
              return _context.abrupt("return", errors);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    /**
     * Удаление динамической группы полей
     */

    _this.onRemoveDynamicGroup = function () {
      var selectedDynamicGroup = _this.state.selectedDynamicGroup;

      if (selectedDynamicGroup) {
        var dynamicGroupValues = _this.state.dynamicGroupValues;
        var name = selectedDynamicGroup.name,
            position = selectedDynamicGroup.position;

        var newDynamicGroupValuesArray = _toConsumableArray(dynamicGroupValues[name]);

        newDynamicGroupValuesArray.splice(position, 1);

        _this.setState({
          pristine: false,
          selectedDynamicGroup: undefined,
          dynamicGroupValues: _objectSpread({}, dynamicGroupValues, _defineProperty({}, name, newDynamicGroupValuesArray))
        }, function () {
          _this.handleFormChange(GROUP_SEPARATOR + name);

          _this.valueObserver();
        });
      }
    };
    /**
     * Рендер группы полей
     * @param group
     * @param index
     */


    _this.renderGroup = function (group, index) {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          type = _this$props2.type,
          slim = _this$props2.slim;
      var asSlim = type === 'filter' || !!slim;
      return React.createElement(Grid, {
        item: true,
        xs: 12,
        key: "group_".concat(index)
      }, React.createElement("div", {
        className: classes.groupBox
      }, React.createElement("div", {
        className: classes.groupHeader
      }, React.createElement(Typography, {
        variant: 'subtitle2',
        className: classnames(_defineProperty({}, classes.groupHeaderTitleSlim, asSlim))
      }, group.title), group.dynamic && _this.renderDynamicGroupActions(group.name)), group.dynamic ? _this.renderDynamicGroup(group) : React.createElement("div", {
        className: classnames(classes.groupForm, _defineProperty({}, classes.slimGroupForm, asSlim))
      }, React.createElement(Grid, {
        container: true,
        alignItems: 'flex-start',
        spacing: asSlim ? 1 : 2
      }, _this.renderFields(group.fields, group.name)))));
    };
    /**
     * Рендер динамических групп полей
     * @param group
     */


    _this.renderDynamicGroup = function (group) {
      var _this$state14 = _this.state,
          dynamicGroupValues = _this$state14.dynamicGroupValues,
          openedDynamicGroup = _this$state14.openedDynamicGroup;
      return React.createElement(React.Fragment, null, dynamicGroupValues[group.name].length > 0 && _this.renderDynamicGroupTable(group), openedDynamicGroup === group.name && _this.renderDynamicGroupFields(group));
    };

    _this.renderDynamicGroupTable = function (group) {
      var _this$state15 = _this.state,
          dynamicGroupValues = _this$state15.dynamicGroupValues,
          selectedDynamicGroup = _this$state15.selectedDynamicGroup;
      var groupFields = group.fields,
          groupName = group.name;
      var _this$props3 = _this.props,
          classes = _this$props3.classes,
          type = _this$props3.type,
          slim = _this$props3.slim;
      var asSlim = type === 'filter' || !!slim;
      var uniqueGroupFields = uniqBy(groupFields, 'name').filter(function (groupField) {
        return groupField.type !== FieldType.Hidden && !groupField.hideInDynamicGroupTable;
      });
      return React.createElement(Table, {
        size: 'small'
      }, React.createElement(TableHead, null, React.createElement(TableRow, {
        className: classnames(_defineProperty({}, classes.dynamicGroupTableRowSlim, asSlim))
      }, uniqueGroupFields.map(function (field, index) {
        return React.createElement(TableCell, {
          key: index,
          className: classnames(_defineProperty({}, classes.dynamicGroupTableCellSlim, asSlim))
        }, field.label);
      }))), React.createElement(TableBody, null, dynamicGroupValues[groupName].map(function (values, rowIndex) {
        var isSelected = selectedDynamicGroup && selectedDynamicGroup.name === groupName && selectedDynamicGroup.position === rowIndex;
        return React.createElement(TableRow, {
          key: rowIndex,
          className: classnames(_defineProperty({}, classes.dynamicGroupTableRowSlim, asSlim)),
          onClick: function onClick() {
            return _this.onSelectDynamicGroup(groupName, rowIndex);
          },
          onDoubleClick: function onDoubleClick() {
            return _this.onOpenDynamicGroupEditForm({
              name: groupName,
              position: rowIndex
            });
          },
          selected: isSelected
        }, uniqueGroupFields.map(function (groupField, cellIndex) {
          return React.createElement(TableCell, {
            key: cellIndex,
            className: classnames(_defineProperty({}, classes.dynamicGroupTableCellSlim, asSlim))
          }, _this.hiddenFields.includes("".concat(groupField.name).concat(GROUP_SEPARATOR).concat(groupName)) ? '' : _this.getDynamicGroupGridValue(groupField, values[groupField.name]));
        }));
      })));
    };
    /**
     * Рендер формы динамической группы
     * @param group
     */


    _this.renderDynamicGroupFields = function (group) {
      var _this$props4 = _this.props,
          classes = _this$props4.classes,
          readonly = _this$props4.readonly,
          type = _this$props4.type,
          slim = _this$props4.slim;
      var notSavedDynamicGroup = _this.state.notSavedDynamicGroup;
      var asSlim = type === 'filter' || !!slim;
      var isGroupErrors = false;

      if (_this._validator) {
        // проверяем наличие ошибок по вхождению наименования группы
        isGroupErrors = _this.isGroupErrors(group.name);
      }

      return React.createElement("div", {
        className: classnames(classes.groupForm, _defineProperty({}, classes.slimGroupForm, asSlim))
      }, notSavedDynamicGroup && notSavedDynamicGroup === group.name && React.createElement("div", {
        className: classes.dynamicGroupErrors
      }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0433\u0440\u0443\u043F\u043F\u044B \u043D\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B!"), React.createElement(Grid, {
        container: true,
        alignItems: 'flex-start',
        spacing: asSlim ? 1 : 2
      }, _this.renderFields(group.fields, group.name), React.createElement(Grid, {
        item: true,
        xs: 12
      }, React.createElement("div", {
        className: classes.dynamicGroupButtons
      }, React.createElement(Button, {
        id: 'dynamicGroupFormCancel',
        type: 'button',
        variant: 'contained',
        size: 'small',
        onClick: function onClick() {
          return _this.onCloseDynamicGroupForm();
        },
        className: classnames(_defineProperty({}, classes.buttonSlim, asSlim))
      }, "\u041E\u0442\u043C\u0435\u043D\u0430"), !readonly && React.createElement(Button, {
        id: 'dynamicGroupFormSave',
        type: 'button',
        variant: 'contained',
        size: 'small',
        color: 'primary',
        disabled: isGroupErrors,
        style: {
          marginLeft: 16
        },
        onClick: function onClick() {
          return _this.onSaveDynamicGroup();
        },
        className: classnames(_defineProperty({}, classes.buttonSlim, asSlim))
      }, "\u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C")))));
    };
    /**
     * Рендер кнопок управления динамическими группами
     * @param name
     */


    _this.renderDynamicGroupActions = function (name) {
      var _this$props5 = _this.props,
          classes = _this$props5.classes,
          readonly = _this$props5.readonly,
          slim = _this$props5.slim,
          type = _this$props5.type;
      var _this$state16 = _this.state,
          selectedDynamicGroup = _this$state16.selectedDynamicGroup,
          openedDynamicGroup = _this$state16.openedDynamicGroup;
      var isAddButtonDisabled = !!openedDynamicGroup;
      var isOtherButtonsDisabled = !(selectedDynamicGroup && selectedDynamicGroup.name === name) || !!openedDynamicGroup;
      var asSlim = type === 'filter' || !!slim;

      if (readonly) {
        return null;
      }

      return React.createElement("div", null, React.createElement(Tooltip, {
        title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443",
        onClick: function onClick() {
          return !isAddButtonDisabled && _this.onOpenDynamicGroupAddForm(name);
        }
      }, React.createElement("div", {
        className: classes.groupButton
      }, React.createElement(IconButton, {
        disabled: isAddButtonDisabled,
        size: asSlim ? 'small' : 'medium'
      }, React.createElement(Icon, {
        fontSize: 'small',
        color: 'inherit'
      }, "add")))), React.createElement(Tooltip, {
        title: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443",
        onClick: function onClick() {
          return !isOtherButtonsDisabled && _this.onOpenDynamicGroupEditForm();
        }
      }, React.createElement("div", {
        className: classes.groupButton
      }, React.createElement(IconButton, {
        disabled: isOtherButtonsDisabled,
        size: asSlim ? 'small' : 'medium'
      }, React.createElement(Icon, {
        fontSize: 'small',
        color: 'inherit'
      }, "edit")))), React.createElement(Tooltip, {
        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443",
        onClick: function onClick() {
          return !isOtherButtonsDisabled && _this.onRemoveDynamicGroup();
        }
      }, React.createElement("div", {
        className: classes.groupButton
      }, React.createElement(IconButton, {
        disabled: isOtherButtonsDisabled,
        size: asSlim ? 'small' : 'medium'
      }, React.createElement(Icon, {
        fontSize: 'small',
        color: 'inherit'
      }, "delete")))));
    };
    /**
     * Добавление динамического поля
     * @param field
     * @param id
     */


    _this.onAddDynamicField = function (field, id) {
      var dynamicValues = _this.state.dynamicValues;

      _this.setState({
        dynamicValues: _objectSpread({}, dynamicValues, _defineProperty({}, id, [].concat(_toConsumableArray(dynamicValues[id]), [getDefaultValueByFieldType(field.type, field.value)])))
      }, function () {
        _this.handleFormChange(id + POSITION_SEPARATOR + dynamicValues[id].length.toString());
      });
    };
    /**
     * Удаление динамического поля
     * @param id
     * @param position
     */


    _this.onDeleteDynamicField = function (id, position) {
      var _this$state17 = _this.state,
          dynamicValues = _this$state17.dynamicValues,
          errors = _this$state17.errors;

      var newFieldDynamicValues = _toConsumableArray(dynamicValues[id]);

      newFieldDynamicValues.splice(position, 1); // если для удаляемого значения есть ошибка, то убираем ее

      var dynamicFieldId = "".concat(id).concat(POSITION_SEPARATOR).concat(position);
      var newErrors = errors;

      if (errors && errors[dynamicFieldId]) {
        newErrors = omit(errors, dynamicFieldId);
      }

      _this.setState({
        pristine: false,
        dynamicValues: _objectSpread({}, dynamicValues, _defineProperty({}, id, newFieldDynamicValues)),
        errors: newErrors
      }, function () {
        _this.handleFormChange(id);
      });
    };
    /**
     * Рендер динамических полей
     * @param field
     * @param ID
     */


    _this.renderDynamicFields = function (field, ID) {
      var _this$props6 = _this.props,
          classes = _this$props6.classes,
          type = _this$props6.type,
          slim = _this$props6.slim;
      var dynamicValues = _this.state.dynamicValues;
      var currentDynamicValues = isArray(dynamicValues[ID]) ? dynamicValues[ID] : [];
      var isNotOnly = currentDynamicValues.length > 1;
      var asSlim = type === 'filter' || !!slim;
      return currentDynamicValues.map(function (dynamicValue, index) {
        var dynamicFieldId = "".concat(ID).concat(POSITION_SEPARATOR).concat(index);
        var isLast = index === currentDynamicValues.length - 1;
        return React.createElement("div", {
          className: classnames(classes.fieldContainer, classes.dynamicField),
          key: dynamicFieldId
        }, _this.renderField(field, dynamicFieldId), React.createElement("div", {
          className: classnames(classes.fieldActions, asSlim ? classes.slimFieldActions : '')
        }, isLast && React.createElement(Tooltip, {
          title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u043B\u0435",
          onClick: function onClick() {
            return _this.onAddDynamicField(field, ID);
          }
        }, React.createElement("div", {
          className: classes.groupButton
        }, React.createElement(IconButton, {
          size: 'small'
        }, React.createElement(Icon, {
          color: 'inherit',
          fontSize: asSlim ? 'small' : 'default'
        }, "add")))), isNotOnly && React.createElement(Tooltip, {
          title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u0435",
          onClick: function onClick() {
            return _this.onDeleteDynamicField(ID, index);
          }
        }, React.createElement("div", {
          className: classes.groupButton
        }, React.createElement(IconButton, {
          size: 'small'
        }, React.createElement(Icon, {
          color: 'inherit',
          fontSize: asSlim ? 'small' : 'default'
        }, "clear"))))));
      });
    };
    /**
     * Рендер полей
     * @param fields
     * @param groupName
     */


    _this.renderFields = function (fields, groupName) {
      return fields.map(function (field, index) {
        if ('fields' in field) {
          return _this.renderGroup(field, index);
        } else {
          var ID = field.name;

          if (!isUndefined(groupName)) {
            ID += GROUP_SEPARATOR + groupName;
          }

          return _this.renderFieldGridItem(field, ID);
        }
      });
    };
    /**
     * Рендер элемента сетки
     * @param field
     * @param ID
     */


    _this.renderFieldGridItem = function (field, ID) {
      if (_this.isFieldHidden(field)) {
        if (!_this.hiddenFields.includes(ID)) {
          _this.hiddenFields.push(ID);
        }

        return null;
      } else if (_this.hiddenFields.includes(ID)) {
        _this.hiddenFields.splice(_this.hiddenFields.indexOf(ID), 1);
      }

      var classes = _this.props.classes;
      return React.createElement(Grid, {
        key: ID,
        item: true,
        xs: 'gridSize' in field ? field.gridSize : 'auto',
        className: classnames(field.type === FieldType.Hidden ? classes.hiddenInputWrap : '', 'gridOffsetLeft' in field ? classes["gridOffsetLeft".concat(field.gridOffsetLeft)] : '', 'gridOffsetRight' in field ? classes["gridOffsetRight".concat(field.gridOffsetRight)] : '')
      }, 'dynamic' in field && field.dynamic ? _this.renderDynamicFields(field, ID) : _this.renderField(field, ID));
    };
    /**
     * Рендер поля
     * @param field
     * @param ID
     */


    _this.renderField = function (field, ID) {
      var validationField = _this.state.validationField;
      var _this$props7 = _this.props,
          type = _this$props7.type,
          slim = _this$props7.slim; // если есть ошибка, то берем первое значение из массива

      var error = _this.state.errors[ID] && _this.state.errors[ID][0];

      var required = _this._validator && _this._validator.isRequiredField(ID);

      var value = _this.getFieldValue(ID);

      var asSlim = type === 'filter' || !!slim;
      return React.createElement(Field, {
        id: ID,
        required: required,
        field: field,
        value: value,
        error: error,
        onFieldChange: _this.onFieldChange,
        slim: asSlim,
        disabled: _this.isFieldDisabled(field),
        preFilterValues: _this.getFieldPreFilterValues(field, ID),
        validation: validationField === ID
      });
    };
    /**
     * Рендер кнопок формы
     */


    _this.renderButtons = function () {
      var _this$props8 = _this.props,
          classes = _this$props8.classes,
          type = _this$props8.type,
          onCloseModal = _this$props8.onCloseModal,
          readonly = _this$props8.readonly,
          slim = _this$props8.slim;
      var buttons = _this.props.buttons;
      var additionalButtons = _this.props.additionalButtons;
      var _this$state18 = _this.state,
          submitting = _this$state18.submitting,
          pristine = _this$state18.pristine,
          errors = _this$state18.errors;
      var asGridFilter = type === 'filter';
      var asSlim = asGridFilter || !!slim;

      if (!buttons) {
        if (type === 'find') {
          buttons = [{
            label: 'Найти',
            type: 'submit'
          }, {
            label: 'Очистить',
            type: 'reset'
          }, {
            label: 'Отмена',
            func: onCloseModal
          }];
        } else {
          buttons = [].concat(_toConsumableArray(!readonly ? [{
            label: asGridFilter ? 'Найти' : 'Сохранить',
            icon: asGridFilter && React.createElement(Icon, {
              fontSize: 'small',
              className: classes.buttonLeftIcon
            }, "search"),
            size: asSlim ? 'small' : 'medium',
            type: 'submit'
          }] : []), [{
            label: 'Очистить',
            size: asSlim ? 'small' : 'medium',
            type: 'reset'
          }]);
        }
      }

      if ((!buttons || buttons.length === 0) && (!additionalButtons || additionalButtons.length === 0)) return null;
      return React.createElement(Grid, {
        item: true,
        xs: 12,
        style: {
          marginTop: asGridFilter ? 0 : 16
        }
      }, React.createElement("div", {
        className: classes.modalButtons
      }, React.createElement("div", null, additionalButtons && additionalButtons.length > 0 && additionalButtons.map(function (button, index) {
        return React.createElement(Button, {
          key: "form-additional-button-".concat(index),
          color: button.color || 'primary',
          variant: 'contained',
          size: button.size || 'small',
          onClick: button.func,
          disabled: button.disabled,
          className: classnames(_defineProperty({}, classes.buttonSlim, asSlim)),
          startIcon: button.icon ? React.createElement(Icon, {
            fontSize: 'small'
          }, button.icon) : undefined
        }, button.label);
      })), React.createElement("div", null, buttons && buttons.length > 0 && buttons.map(function (button, index) {
        var buttonType = button.type;

        switch (buttonType) {
          case 'submit':
            return React.createElement(Button, {
              key: "form-button-".concat(index),
              type: 'submit',
              color: button.color || 'primary',
              variant: 'contained',
              size: button.size || 'small',
              disabled: submitting || pristine || !isEmpty(errors),
              className: classnames(_defineProperty({}, classes.buttonSlim, asSlim)),
              startIcon: button.icon ? React.createElement(Icon, {
                fontSize: 'small'
              }, button.icon) : undefined
            }, button.label);

          case 'reset':
            return React.createElement(Button, {
              key: "form-button-".concat(index),
              type: 'reset',
              color: button.color || 'default',
              variant: 'contained',
              size: button.size || 'small',
              onClick: button.func || _this.onReset,
              disabled: submitting || !asGridFilter && pristine,
              className: classnames(_defineProperty({}, classes.buttonSlim, asSlim)),
              startIcon: button.icon ? React.createElement(Icon, {
                fontSize: 'small'
              }, button.icon) : undefined
            }, button.label || 'Очистить');

          default:
            return React.createElement(Button, {
              key: "form-button-".concat(index),
              color: button.color || 'primary',
              variant: 'contained',
              size: button.size || 'small',
              onClick: button.func,
              className: classnames(_defineProperty({}, classes.buttonSlim, asSlim)),
              startIcon: button.icon ? React.createElement(Icon, {
                fontSize: 'small'
              }, button.icon) : undefined
            }, button.label);
        }
      }))));
    };

    _this.renderFormContent = function () {
      var _this$props9 = _this.props,
          fields = _this$props9.fields,
          type = _this$props9.type,
          slim = _this$props9.slim;
      var asSlim = type === 'filter' || !!slim;
      return React.createElement(Grid, {
        container: true,
        alignItems: 'flex-start',
        spacing: asSlim ? 1 : 2
      }, _this.renderFields(fields), _this.renderButtons());
    };

    var _init = init(props.fields, props.values),
        _defaultValues = _init._defaultValues,
        _defaultDynamicValues = _init._defaultDynamicValues,
        _defaultDynamicGroupValues = _init._defaultDynamicGroupValues,
        _labels = _init._labels,
        _rules = _init._rules,
        _excludedDependencies = _init._excludedDependencies,
        _dependsOnFields = _init._dependsOnFields,
        _groupNames = _init._groupNames;

    _this._labels = _labels;
    _this._excludedDependencies = _excludedDependencies;
    _this._dependsOnFields = _dependsOnFields;
    _this._groupNames = _groupNames;
    _this.fieldDependency = new FormDependency(_this.getFieldValue); // Если есть правила, то инициируем валидатор согласно правилам

    if (!isEmpty(_rules)) {
      _this._validator = new Validation(_rules, _this.fieldDependency);
    } // Инициализация стейта


    _this.state = {
      initValues: props.values,
      values: _defaultValues,
      dynamicValues: _defaultDynamicValues,
      dynamicGroupValues: _defaultDynamicGroupValues,
      defaultValues: _defaultValues,
      defaultDynamicValues: _defaultDynamicValues,
      defaultDynamicGroupValues: _defaultDynamicGroupValues,
      errors: props.errors || {},
      submitting: false,
      pristine: true,
      submitted: false
    };
    _this.formHelpers = {
      getFieldValue: _this.getFieldValue,
      getFormValues: _this.getFormValues
    };

    _this.valueObserver();

    return _this;
  }

  _createClass(Form, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props10 = this.props,
          newValues = _this$props10.values,
          newErrors = _this$props10.errors;

      if (prevProps.values !== newValues) {
        // Если значения полей в пропсах поменялись, то следует выполнить перевалидацию тех полей,
        // что уже имеют ошибки.
        var errors = this.state.errors;
        Object.keys(errors).forEach(function (ID) {
          _this2.validateField(ID);
        });
      }

      if (prevProps.errors !== newErrors) {
        var _errors = this.state.errors;

        if (newErrors && Object.keys(newErrors).length > 0) {
          this.setState({
            errors: _objectSpread({}, newErrors, {}, _errors)
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          embedded = _this$props11.embedded,
          loading = _this$props11.loading,
          classes = _this$props11.classes;
      var _this$state19 = this.state,
          submitting = _this$state19.submitting,
          showSubmitConfirm = _this$state19.showSubmitConfirm;
      return React.createElement("div", {
        className: classes.formContainer
      }, embedded ? this.renderFormContent() : React.createElement("form", {
        onSubmit: this.onSubmit,
        noValidate: true,
        autoComplete: 'off'
      }, this.renderFormContent()), showSubmitConfirm && React.createElement(Dialog, {
        open: true,
        onClose: this.onCloseSubmitConfirm,
        disableEnforceFocus: true,
        confirm: true,
        onConfirm: this.onSubmitConfirm,
        title: "\u0412 \u0444\u043E\u0440\u043C\u0435 \u0438\u043C\u0435\u044E\u0442\u0441\u044F \u043D\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435. \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0431\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F?"
      }), (loading || submitting) && React.createElement(Loader, {
        wrapper: true
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      // Если изменились данные
      if (!isEqual(nextProps.values, prevState.initValues)) {
        var nextState = {};
        nextState.initValues = nextProps.values;
        nextState.dynamicGroupValues = getMergedValues('dynamicGroupValues', prevState, nextProps.values);
        nextState.dynamicValues = getMergedValues('dynamicValues', prevState, nextProps.values);
        nextState.values = getMergedValues('values', prevState, nextProps.values); // todo нужно как-то разделять обновление данных и добавление данных

        if (isUndefined(prevState.initValues)) {
          // если форма инициализировалась с отсутствующими данными
          nextState.defaultValues = getMergedValues('defaultValues', prevState, nextProps.values);
          nextState.defaultDynamicValues = getMergedValues('defaultDynamicValues', prevState, nextProps.values);
          nextState.defaultDynamicGroupValues = getMergedValues('defaultDynamicGroupValues', prevState, nextProps.values);
        } else {
          // если пришли дополнительные данные
          nextState.pristine = false;
        }

        if (nextProps.valueObserver) {
          nextProps.valueObserver(_objectSpread({}, nextState.values, {}, nextState.dynamicValues, {}, nextState.dynamicGroupValues));
        }

        return nextState;
      }

      return null;
    }
  }]);

  return Form;
}(React.Component);
export default withStyles(styles, {
  name: 'Form'
})(Form);